export default __webpack_public_path__ + "static/media/percentage.03c251ba.svg";